export default {"src":"/_next/static/media/speedAnalyzerBig.574ea4da.svg","height":97,"width":202};